export default "__VITE_ASSET__DHNVPFYN__"